module.exports = __webpack_public_path__ + "static/media/Orofacialpainclinicimage.0d32c0a4.jpeg";